import { createApi } from "@reduxjs/toolkit/query/react";

import apiBaseQuery from "./axiosBaseQuery";
import authBaseQuery from "./authBaseQuery";

export const USERS_API_REDUCER_KEY = "usersApi";
export const NEW_USERS_API_REDUCER_KEY = "newUserApi";

export const usersApi = createApi({
  reducerPath: USERS_API_REDUCER_KEY,
  baseQuery: apiBaseQuery,
  tagTypes: ["user"],
  endpoints: (builder) => ({
    getMe: builder.query({
      query: () => ({
        url: "/admin/users/me/",
      }),
      providesTags: ["user"],
    }),

    getUsers: builder.query({
      query: ({ page, limit }) => ({
        url: `/admin/users/`,
        params: {
          page: page || 1,
          limit: limit || 100,
        },
      }),
      providesTags: ["user"],
    }),

    getUser: builder.query({
      query: (id) => {
        if (!id) {
          return;
        }
        return {
          url: `/admin/users/${id}/`,
        };
      },
      providesTags: ["user"],
    }),

    createUser: builder.mutation({
      query: (body) => {
        return {
          url: "/admin/users/",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),
    updateUser: builder.mutation({
      query: ({ id, ...rest }) => {
        return {
          url: `/admin/users/${id}/`,
          method: "PUT",
          body: rest,
        };
      },
      invalidatesTags: ["user"],
    }),
    deleteUser: builder.mutation({
      query: (id) => {
        return {
          url: `/admin/users/${id}/`,
          method: "DELETE",
        };
      },
      invalidatesTags: ["user"],
    }),
    forgotPassword: builder.mutation({
      query: (body) => {
        return {
          url: `/admin/users/email-reset/`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),
    resetPassword: builder.mutation({
      query: (body) => {
        return {
          url: `/admin/users/reset-password`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),
  }),
});

export const newUserApi = createApi({
  reducerPath: NEW_USERS_API_REDUCER_KEY,
  baseQuery: authBaseQuery,
  tagTypes: ['users'],
  endpoints: (builder) => ({
    createNewUser: builder.mutation({
      query: (body) => {
        return {
          url: "/core/user/register",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),
    getAllUsers: builder.query({
      query: (body) => {
        return {
          url: "/core/users",
          method: "GET",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),

    updatepassword: builder.mutation({
      query: (body) => {
        return {
          url: "/core/password/update",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),


    forgotPasswordtomail: builder.mutation({
      query: (body) => {
        return {
          url: "/core/password/forgot",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),

    resetPasswordtomail: builder.mutation({
      query: (body) => {
        return {
          url: "/core/password/reset",
          method: "POST",
          body,
        };
      },
      invalidatesTags: ["user"],
    }),

  })
})
export const {
  useCreateUserMutation,
  useGetMeQuery,
  useGetUserQuery,
  useGetUsersQuery,
  useUpdateUserMutation,
  useDeleteUserMutation,
  useLazyGetMeQuery,
  useForgotPasswordMutation,
  useResetPasswordMutation,
} = usersApi;

export const { useCreateNewUserMutation, useUpdatepasswordMutation, useResetPasswordtomailMutation, useForgotPasswordtomailMutation, useGetAllUsersQuery } = newUserApi